__turbopack_context__.v({
  "back-button": "CareersDetail-module-scss-module__BWtUBq__back-button",
  "career-content": "CareersDetail-module-scss-module__BWtUBq__career-content",
  "career-detail": "CareersDetail-module-scss-module__BWtUBq__career-detail",
  "container": "CareersDetail-module-scss-module__BWtUBq__container",
});
